import { Link } from 'react-router';
import { FlagLanguageSwitcher } from '../FlagLanguageSwitcher';

export const MarketingHeader = () => {
  // Get app URL from environment or use default
  const appUrl = import.meta.env.VITE_APP_URL || 'https://app2.peetrack.live';

  return (
    <header className="sticky top-0 z-50 w-full border-b bg-white/95 backdrop-blur supports-[backdrop-filter]:bg-white/60">
      <div className="container mx-auto flex h-16 items-center justify-between px-4">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-2 font-bold text-xl">
          <img
            src="/assets/peetrack_logo.png"
            alt="PeeTrack Logo"
            className="h-8 w-8 object-contain"
          />
          <span className="text-gray-900">PeeTrack</span>
        </Link>

        {/* Navigation */}
        <nav className="hidden md:flex items-center gap-6">
          <Link
            to="/"
            className="text-sm font-medium text-gray-700 hover:text-cyan-600 transition-colors"
          >
            Home
          </Link>
          <Link
            to="/pricing"
            className="text-sm font-medium text-gray-700 hover:text-cyan-600 transition-colors"
          >
            Pricing
          </Link>
          <Link
            to="/blog"
            className="text-sm font-medium text-gray-700 hover:text-cyan-600 transition-colors"
          >
            Blog
          </Link>
          <Link
            to="/privacy"
            className="text-sm font-medium text-gray-700 hover:text-cyan-600 transition-colors"
          >
            Privacy
          </Link>
          <Link
            to="/terms"
            className="text-sm font-medium text-gray-700 hover:text-cyan-600 transition-colors"
          >
            Terms
          </Link>
        </nav>

        {/* Language Switcher & CTA Button */}
        <div className="flex items-center gap-3">
          <FlagLanguageSwitcher />
          <a
            href={appUrl}
            className="inline-flex items-center justify-center rounded-md bg-cyan-500 px-6 py-2 text-sm font-semibold text-white hover:bg-cyan-600 transition-colors shadow-sm"
          >
            Get Started
          </a>
        </div>
      </div>
    </header>
  );
};
